import { css } from '@emotion/css';

export const gradientBorderClass = css`
  background: linear-gradient(135deg, #5b21b6, #ec4899, #a78bfa);
  background-size: 300% 300%;
  padding: 2px;
  border-radius: 10px;
  transition: background-position 0.3s ease;

  box-shadow:
    0px 1px 1px rgba(91, 33, 182, 0.02),
    0px 5px 4px rgba(91, 33, 182, 0.03),
    0px 12px 9px rgba(91, 33, 182, 0.05),
    0px 20px 15px rgba(91, 33, 182, 0.06),
    0px 32px 24px rgba(91, 33, 182, 0.08);

  &:hover {
    animation: borderMove 3s ease-in-out infinite;
  }

  @keyframes borderMove {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;
